<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Redemption PIN Code</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <form @submit.prevent="save">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="form-group row align-items-center">
                <label class="col-md-1 fit-content">PIN</label>
                <div class="col-md-2 pl-0">
                  <input
                    :disabled="tokenObj.role == userRoleMerchantUser"
                    type="text"
                    v-model="pin"
                    class="form-control"
                    maxlength="20"
                    minlength="3"
                    required
                  />
                </div>
                <div
                  class="col-md-1"
                  v-if="tokenObj.role == userRoleMerchantAdmin"
                >
                  <button type="submit" class="btn btn-primary">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      userRoleMerchantAdmin: config.USER_ROLE_MERCHANT_ADMIN,
      userRoleMerchantUser: config.USER_ROLE_MERCHANT_USER,
      pin: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
  },
  methods: {
    save() {
      let param = {
        merchant_id: this.tokenObj.merchant_id,
        pin: this.pin,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to update the PIN Code?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.savePinCode(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    getPinCode() {
      let param = {
        merchant_id: this.tokenObj.merchant_id,
      };
      this.$store.state.isLoading = true;
      API.getPinCode(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.pin = response.data.pin;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
  },
  created() {
    this.getPinCode();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Merchant/RedemptionPINCode.vue